/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled,  { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight } from '../../../components/Text';
import { Breakpoints } from "../../../constants/Breakpoints";
import { mediaHelper } from "../../../utils/src";
import {FiraSansBold} from '../../../components/Text';
import {darken} from 'polished';

const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
  return css`
  color: ${color};
  background-color: ${bg};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${bgFocus};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${bgActive};
  }
  ${args.length >= 1 ? args.join('\n') : ''}
  `;
}

const primaryMixin = generateStyle(Colors.WHITE, Colors.BLUE, darken(0.1, Colors.BLUE), darken(0.2, Colors.BLUE));
const secundaryMixin = generateStyle(Colors.WHITE, Colors.PURPLE, darken(0.1, Colors.PURPLE), darken(0.2, Colors.PURPLE));
const thirdMixin = generateStyle(Colors.WHITE, Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]));


/* const outlinePrimaryMixin = generateStyle(Colors.WHITE,Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]),
[`border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${Colors.SECONDARY};`,`${FiraSansBold}`])
 */


const outlinePrimaryMixin = css`
border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${Colors.BLUE};
${FiraSansBold}
  color: ${Colors.WHITE};
  padding: 4px 16px;
  text-transform: none;
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: white;
    border-color: ${Colors.BLUE};
    background: ${Colors.BLUE};
  }
  &:active:not(:disabled) {
    background-color: ${darken(0.2, Colors.BLUE)};
  }
`;

const forthMixin = css`
  padding: 0.75rem 0.95rem;
  color: ${Colors.GRAY[6]};
`;

const grayTextMixin = css`
  padding: 8px 0;
  color: ${Colors.GRAY[0]};
  &:active:not(:disabled) {
    color: ${Colors.GRAY[3]};
  }
`;

const noBorderPrimaryMixin = css`
  color: ${Colors.BLUE};
  padding: 6px 16px;
  ${FiraSansBold}
  text-transform: none;
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    color: ${Colors.PRIMARY};
  }
  &:active:not(:disabled) {
    color: ${Colors.PRIMARY};
  }
`;

// Size mixin
const smallMixin = css`
  height: 32px;
`;

export const Dialog = styled.div`
  margin-left: 2%;
  ${({ canShow }) =>
  canShow
    ? css`
        display: block;
        `
    : `display: none;`
  }
`;


export const Heading = styled.div`
  background: ${Colors.WHITE};
  margin-left: 1%;
  display:flex;
  align-items:center;
  justify-content: space-between;
  color: ${Colors.BLACK};
  padding: 5px 10px;
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 10%;
  position: relative;

  ${mediaHelper.sm`
    padding: 10px 15px;
    font-size: 18px;
  `}
`;

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;

export const Button = styled.button`
  padding: 0.10rem 0.20rem;
  width: auto;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  white-space: nowrap;
  margin: 10px 10px 0px 10px;

  ${FiraSansBold}

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease, border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ outlinePrimary }) => outlinePrimary && outlinePrimaryMixin}
  ${({ text }) => text && grayTextMixin}
  ${({ primary }) => primary && primaryMixin}
  ${({ secundary }) => secundary && secundaryMixin}
  ${({ third }) => third && thirdMixin}
  ${({ noBorderPrimary }) => noBorderPrimary && noBorderPrimaryMixin}
  ${({ forth }) => forth && forthMixin}

  ${({ sm }) => sm && smallMixin}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  @media(min-width: ${Breakpoints.sm}) {  
    padding: .75rem 3.75rem;
    width: auto;
  }
  @media (min-width: ${Breakpoints.xl}) and (max-width: ${Breakpoints.xxl}) {  
    padding: .75rem 2.5rem;
    width: 100%;
    font-size: 13px;
    text-align: center;
    
  }

  @media (min-width: ${Breakpoints.xxs}) and (max-width: ${Breakpoints.lg}) {  
    padding: .75rem 2.5rem;
    width: 100%;
    font-size: 16px;
    text-align: center;
    
  }

`;

export const ButtonContent = styled.div`
    display:flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 2%;
    padding: 0px 20px 0px 0px;
    background-color:#FFF;

    @media (max-width: ${Breakpoints.lg}) {  
      flex-wrap: wrap;
      padding-right: 10px;
      width: 100%;
    }    
  
`;

